var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-headline",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeText,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-headline-content",
                      class: [
                        _vm.currentStyle,
                        _vm.currentHeight,
                        _vm.hasGradient ? _vm.currentGradient : "",
                      ],
                      style: _vm.headlineStyle,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-headline-iconbox",
                          class: [
                            "border-" + _vm.currentIconColor,
                            _vm.currentHeight,
                          ],
                        },
                        [
                          _c("div", {
                            staticClass: "icon-layer",
                            class: [
                              "icon-" +
                                _vm.currentIconColor +
                                "-" +
                                _vm.currentIcon,
                              _vm.currentHeight,
                            ],
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-headline-textbox",
                          class: [
                            "border-" + _vm.currentIconColor,
                            _vm.currentHeight,
                          ],
                          style:
                            _vm.currentStyle === "ribbon"
                              ? _vm.headlineTextboxStyle.rgba
                              : {},
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-headline-title",
                              style:
                                _vm.currentStyle === "vertical"
                                  ? _vm.headlineTextboxStyle.hex
                                  : {},
                            },
                            [
                              _c(
                                "h1",
                                {
                                  style: _vm.textStyle,
                                },
                                [_vm._v(_vm._s(_vm.currentTitle))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasSubtitle && _vm.subtitleIsSet,
                                  expression: "hasSubtitle && subtitleIsSet",
                                },
                              ],
                              staticClass: "cw-block-headline-subtitle",
                              style:
                                _vm.currentStyle === "vertical"
                                  ? _vm.headlineTextboxStyle.rgba
                                  : {},
                            },
                            [
                              _c(
                                "h2",
                                {
                                  style: _vm.textStyle,
                                },
                                [_vm._v(_vm._s(_vm.currentSubtitle))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasSecondSubtitle,
                                  expression: "hasSecondSubtitle",
                                },
                              ],
                              staticClass: "cw-block-headline-second-subtitle",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  style: _vm.textStyle,
                                },
                                [_vm._v(_vm._s(_vm.currentSecondSubtitle))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Layout"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Typ")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentStyle,
                                            expression: "currentStyle",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentStyle = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "heavy",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Große Schrift")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "ribbon",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Band")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "vertical",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Vertikal"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "bigicon_top",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Großes Icon oben")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "bigicon_before",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Großes Icon davor"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "icon_top_lines",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Icon oben mit Linien"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "skew_text",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Schief"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Höhe")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentHeight,
                                            expression: "currentHeight",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentHeight = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "full",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Voll")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "half",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Halb")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "quarter",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Viertel"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Inhalt"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Haupttitel")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentTitle,
                                          expression: "currentTitle",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentTitle,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentTitle = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm.hasSubtitle
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Untertitel")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentSubtitle,
                                              expression: "currentSubtitle",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentSubtitle,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentSubtitle =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasSecondSubtitle
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("2. Untertitel")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentSecondSubtitle,
                                              expression:
                                                "currentSecondSubtitle",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentSecondSubtitle,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentSecondSubtitle =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("Textfarbe")) +
                                          "\n                            "
                                      ),
                                      _c("studip-select", {
                                        attrs: {
                                          options: _vm.colors,
                                          label: "name",
                                          reduce: function reduce(color) {
                                            return color.hex
                                          },
                                          clearable: false,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "open-indicator",
                                              fn: function fn(
                                                selectAttributes
                                              ) {
                                                return [
                                                  _c(
                                                    "span",
                                                    _vm._b(
                                                      {},
                                                      "span",
                                                      selectAttributes,
                                                      false
                                                    ),
                                                    [
                                                      _c("studip-icon", {
                                                        attrs: {
                                                          shape: "arr_1down",
                                                          size: 10,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "no-options",
                                              fn: function fn() {
                                                return [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$gettext(
                                                          "Es steht keine Auswahl zur Verfügung."
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "selected-option",
                                              fn: function fn(option) {
                                                return [
                                                  _c("span", {
                                                    staticClass:
                                                      "vs__option-color",
                                                    style: {
                                                      "background-color":
                                                        option.hex,
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(option.name)),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "option",
                                              fn: function fn(option) {
                                                return [
                                                  _c("span", {
                                                    staticClass:
                                                      "vs__option-color",
                                                    style: {
                                                      "background-color":
                                                        option.hex,
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(option.name)),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1567848121
                                        ),
                                        model: {
                                          value: _vm.currentTextColor,
                                          callback: function callback($$v) {
                                            _vm.currentTextColor = $$v
                                          },
                                          expression: "currentTextColor",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.hasTextBackgroundColor
                                    ? _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Texthintergrundfarbe"
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("studip-select", {
                                            attrs: {
                                              options: _vm.colors,
                                              label: "name",
                                              reduce: function reduce(color) {
                                                return color.hex
                                              },
                                              clearable: false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "open-indicator",
                                                  fn: function fn(
                                                    selectAttributes
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          selectAttributes,
                                                          false
                                                        ),
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape:
                                                                "arr_1down",
                                                              size: 10,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "no-options",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Es steht keine Auswahl zur Verfügung."
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1567848121
                                            ),
                                            model: {
                                              value:
                                                _vm.currentTextBackgroundColor,
                                              callback: function callback($$v) {
                                                _vm.currentTextBackgroundColor =
                                                  $$v
                                              },
                                              expression:
                                                "currentTextBackgroundColor",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasIcon
                                    ? [
                                        _c(
                                          "label",
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(_vm.$gettext("Icon")) +
                                                "\n                                "
                                            ),
                                            _c("studip-select", {
                                              attrs: {
                                                clearable: false,
                                                options: _vm.icons,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "open-indicator",
                                                    fn: function fn(
                                                      selectAttributes
                                                    ) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            selectAttributes,
                                                            false
                                                          ),
                                                          [
                                                            _c("studip-icon", {
                                                              attrs: {
                                                                shape:
                                                                  "arr_1down",
                                                                size: 10,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "no-options",
                                                    fn: function fn() {
                                                      return [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.$gettext(
                                                                "Es steht keine Auswahl zur Verfügung."
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "selected-option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("studip-icon", {
                                                          attrs: {
                                                            shape: option.label,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "vs__option-with-icon",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.label
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("studip-icon", {
                                                          attrs: {
                                                            shape: option.label,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "vs__option-with-icon",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.label
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2875367065
                                              ),
                                              model: {
                                                value: _vm.currentIcon,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.currentIcon = $$v
                                                },
                                                expression: "currentIcon",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("Icon-Farbe")
                                                ) +
                                                "\n                                "
                                            ),
                                            _c("studip-select", {
                                              attrs: {
                                                options: _vm.iconColors,
                                                label: "name",
                                                reduce: function reduce(
                                                  iconColor
                                                ) {
                                                  return iconColor.class
                                                },
                                                clearable: false,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "open-indicator",
                                                    fn: function fn(
                                                      selectAttributes
                                                    ) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._b(
                                                            {},
                                                            "span",
                                                            selectAttributes,
                                                            false
                                                          ),
                                                          [
                                                            _c("studip-icon", {
                                                              attrs: {
                                                                shape:
                                                                  "arr_1down",
                                                                size: 10,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "no-options",
                                                    fn: function fn() {
                                                      return [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              _vm.$gettext(
                                                                "Es steht keine Auswahl zur Verfügung."
                                                              )
                                                            ) +
                                                            "\n                                    "
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "selected-option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              option.hex,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(option.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "option",
                                                    fn: function fn(option) {
                                                      return [
                                                        _c("span", {
                                                          staticClass:
                                                            "vs__option-color",
                                                          style: {
                                                            "background-color":
                                                              option.hex,
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(option.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                173514681
                                              ),
                                              model: {
                                                value: _vm.currentIconColor,
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.currentIconColor = $$v
                                                },
                                                expression: "currentIconColor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 2,
                                name: _vm.$gettext("Hintergrund"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Hintergrundtyp")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentBackgroundType,
                                            expression: "currentBackgroundType",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentBackgroundType = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "color",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Farbe"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "gradient",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Farbverlauf")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "image",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Bild")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "structural-element-image",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Seiten-Bild")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentBackgroundType === "color"
                                    ? _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Hintergrundfarbe")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("studip-select", {
                                            attrs: {
                                              options: _vm.colors,
                                              label: "name",
                                              reduce: function reduce(color) {
                                                return color.hex
                                              },
                                              clearable: false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "open-indicator",
                                                  fn: function fn(
                                                    selectAttributes
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          selectAttributes,
                                                          false
                                                        ),
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape:
                                                                "arr_1down",
                                                              size: 10,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "no-options",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Es steht keine Auswahl zur Verfügung."
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            option.hex,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1567848121
                                            ),
                                            model: {
                                              value: _vm.currentBackgroundColor,
                                              callback: function callback($$v) {
                                                _vm.currentBackgroundColor = $$v
                                              },
                                              expression:
                                                "currentBackgroundColor",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentBackgroundType === "image"
                                    ? _c(
                                        "label",
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Hintergrundbild")
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.currentBackgroundImageId
                                            ? [
                                                _vm.currentBackgroundImageType ===
                                                "file-refs"
                                                  ? [
                                                      _c(
                                                        "StockImageThumbnail",
                                                        {
                                                          attrs: {
                                                            url: _vm.currentBackgroundURL,
                                                            width: "8rem",
                                                            contain: "",
                                                          },
                                                        }
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.currentBackgroundImageType ===
                                                "stock-images"
                                                  ? [
                                                      _vm.selectedStockImage
                                                        ? _c(
                                                            "StockImageSelectableImageCard",
                                                            {
                                                              attrs: {
                                                                "stock-image":
                                                                  _vm.selectedStockImage,
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("label", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "button",
                                                      attrs: {
                                                        type: "button",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.onClickRemoveBackgroundImage,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                        " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Bild entfernen"
                                                            )
                                                          ) +
                                                          "\n                                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.currentBackgroundImageId
                                            ? [
                                                _c("studip-file-chooser", {
                                                  attrs: {
                                                    selectable: "file",
                                                    courseId: _vm.context.id,
                                                    userId: _vm.userId,
                                                    isImage: true,
                                                    excludedCourseFolderTypes:
                                                      _vm.excludedCourseFolderTypes,
                                                  },
                                                  on: {
                                                    select: _vm.onSelectFile,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.currentBackgroundImageId,
                                                    callback: function callback(
                                                      $$v
                                                    ) {
                                                      _vm.currentBackgroundImageId =
                                                        $$v
                                                    },
                                                    expression:
                                                      "currentBackgroundImageId",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-block-start":
                                                        "1em",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$gettext("oder")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "button",
                                                    attrs: {
                                                      type: "button",
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        _vm.showStockImageSelector = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$gettext(
                                                            "Aus dem Bilderpool auswählen"
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.showStockImageSelector
                                                  ? _c("StockImageSelector", {
                                                      on: {
                                                        close: function close(
                                                          $event
                                                        ) {
                                                          _vm.showStockImageSelector = false
                                                        },
                                                        select:
                                                          _vm.onSelectStockImage,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentBackgroundType === "gradient"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Hintergrundfarbverlauf"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentGradient,
                                                expression: "currentGradient",
                                              },
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.currentGradient = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-blue",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Blau"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-purple",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Purpur"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-violet",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Violet"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-red",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Rot"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-orange",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Orange"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-yellow",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Gelb"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-green",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Grün"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-petrol",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Petrol"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "color-grey",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Grau"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "paper",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Papier"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "blueprint",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Blueprint")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "grid",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Gitter"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "blue-bar",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Blaue Balken")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "green-bar",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Grüne Balken")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "faded-sun",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Faded Sun")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "romantic-sun",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Romantic Sun")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "bright-rain",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Bright Rain")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "soft-weather",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$gettext("Soft Weather")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(
                    _vm._s(_vm.$gettext("Informationen zum Blickfang-Block"))
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }